(() => {
  if (customElements.get('aplovio-support')) return;

  class SupportCard extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const {signal} = this.abort;
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-support-open]');
        if (!trigger || !this.contains(trigger) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.open(trigger, signal);
      }, {signal});
    }

    async open(trigger, signal) {
      if (this.pending) return;
      this.pending = true;
      const status = this.querySelector('[data-support-status]');
      const fallback = this.querySelector('[data-support-fallback]');
      const controls = [...this.querySelectorAll('[data-support-open]')];
      fallback.hidden = true;
      status.hidden = false;
      status.textContent = this.dataset.opening;
      for (const control of controls) control.setAttribute('aria-busy', 'true');
      let opened = false;
      try {
        if (this.dataset.action === 'shopify_chat' || this.dataset.action === 'chat') {
          await window.AplovioLazy.asset(this.dataset.chatRuntime, 'script');
          if (!signal.aborted) opened = await window.AplovioChat.open({signal, provider: this.dataset.action === 'chat' ? this.dataset.provider : 'shopify'});
        } else if (this.dataset.action === 'launcher' && this.dataset.launcher) {
          const launcher = document.querySelector(this.dataset.launcher);
          // Only activate an existing external control. Avoid recursive selectors
          // and leave installation/loading of third-party chats with their apps.
          if (launcher && !launcher.closest('aplovio-support') && !launcher.disabled && !launcher.closest('[inert]')) {
            launcher.click();
            opened = true;
          }
        }
      } catch (error) {
        if (!signal.aborted) console.warn('[Aplovio] Support chat is unavailable.', error);
      } finally {
        this.pending = false;
        for (const control of controls) control.removeAttribute('aria-busy');
        status.hidden = true;
        status.textContent = '';
      }
      if (!signal.aborted && this.isConnected && !opened) {
        fallback.hidden = false;
        fallback.querySelector('a').focus({preventScroll: true});
      }
    }

    disconnectedCallback() {
      this.abort?.abort();
    }
  }
  customElements.define('aplovio-support', SupportCard);
})();
